import { Injectable } from '@angular/core';
import { merge, Observable, of as observableOf } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { LocalStorageService } from '../shared/services/local-storage.service';
import { EdgeworthSubstrateDeltaSyncService } from './edgeworth-substrate-deltasync.service';

@Injectable({
    providedIn: 'root'
})
export class EdgeworthUiTimestampService {
    public uiTimestamp: Observable<Date>;
    public static readonly UiSyncTimestampStorageKeyPrefix = `_Edgeworth${window.ewWorkload}LastUiSyncTimestamp`;

    constructor(
        private readonly localStorageService: LocalStorageService,
        private readonly edgeworthDeltaSyncService: EdgeworthSubstrateDeltaSyncService
    ) {
        this.init();
    }

    public getLastUiSyncTimestamp(): Date {
        const rawPreviousTimestamp = this.localStorageService.get(EdgeworthUiTimestampService.UiSyncTimestampStorageKeyPrefix);
        return rawPreviousTimestamp ? new Date(rawPreviousTimestamp) : null;
    }

    private setLastUiSyncTimestamp(date: Date) {
        this.localStorageService.set(EdgeworthUiTimestampService.UiSyncTimestampStorageKeyPrefix, date.toISOString());
    }

    private init() {
        this.uiTimestamp = merge(
            observableOf(this.getLastUiSyncTimestamp()),
            this.edgeworthDeltaSyncService.syncTimestampUpdated.pipe(
                map(() => new Date()),
                tap(date => {
                    this.setLastUiSyncTimestamp(date);
                })
            )
        );
    }
}
